import { Reducer } from "redux";

import { DenialRationaleListResponse } from "../models/Api/RationaleManagement";
import { DenialRationaleTemplateListDispatchTypes } from "../models/DispatchTypes/RationaleManagement";
import { DenialRationalTemplateListActionDispatchTypes } from "../constants/RationaleManagement";

const initialState: DenialRationaleListResponse = {
    loading: true,
    response: {
        totalRows: 0,
        denialRationaleList: [{
            rationaleTemplateId: -1,
            templateName: "",
            serviceRequestType: "",
            rationaleDecision: "",
            discipline: "",
            isActive: false
        }],
    },
};

const DenialRationaleListReducer: Reducer<DenialRationaleListResponse, DenialRationaleTemplateListDispatchTypes> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case DenialRationalTemplateListActionDispatchTypes.POST_DENIAL_RATIONALE_TEMPLATE_LIST_INVOKE: {
            return {
                ...state,
                loading: true,
            };
        }
        case DenialRationalTemplateListActionDispatchTypes.POST_DENIAL_RATIONALE_TEMPLATE_LIST_SUCCESS: {
            return {
                ...state,
                response: action.response,
                loading: false,
            };
        }
        case DenialRationalTemplateListActionDispatchTypes.POST_DENIAL_RATIONALE_TEMPLATE_LIST_ERROR: {
            return {
                response: initialState.response,
                loading: false,
            };
        }
    }
    return state;
};

export default DenialRationaleListReducer;
